import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Data } from '../expert-service-call.index'
import {
  DataLoaderService, ProgressBarService, PriceCalculationService,
  AlternateOptionsService, CommonDataService,
} from '../expert-service-call.index';
import * as _ from 'lodash';

@Component({
  selector: 'expert-view-all',
  templateUrl: './expert-view-all.template.html',
  styleUrls: ['./expert-view-all.component.css']
})
export class ExpertViewAll {

  private subscription: Subscription;
  public saved: Data[] = [];
  public locSaved: Data[] = [];
  public pacSaved: Data[] = [];
  public locPacSaved: Data[] = [];
  private icon: string = "gray";
  public factoryOptions: Data[];
  public localOptions: Data[];
  public packageOptions: Data[];
  private localPackageOptions: Data[];
  public factoryOptionsInit:Data[];
  public localOptionsInit:Data[];
  public localPackageOptionInit:Data[];
  public packageOptionsInit:Data[];
  public allCodesInit:Data[];
  public allCodesChanged:Data[];

  constructor(private dataLoaderService: DataLoaderService,
    private commonDataService: CommonDataService, private progressBarService: ProgressBarService,
    private priceService: PriceCalculationService, 
    private alternateOptionsService: AlternateOptionsService, private progressService: ProgressBarService) {
    this.factoryOptions = this.dataLoaderService.data.facOptions;
    this.localOptions = this.dataLoaderService.data.options;
    this.packageOptions = this.dataLoaderService.data.packages;
    this.localPackageOptions = this.dataLoaderService.data.localPackagesList;
    this.factoryOptionsInit = _.cloneDeep(this.factoryOptions);
    this.localOptionsInit = _.cloneDeep(this.localOptions);
    this.localPackageOptionInit = _.cloneDeep(this.localPackageOptions);
    this.packageOptionsInit = _.cloneDeep(this.packageOptions);
    this.allCodesInit = this.factoryOptionsInit.concat(this.localOptionsInit,this.localPackageOptionInit,this.packageOptionsInit);
    this.allCodesChanged = this.factoryOptions.concat(this.localOptions,this.localPackageOptions,this.packageOptions);
  }

  ngOnInit() {
    this.subscription = this.priceService.notifyObservableNormalComp$.subscribe((selectedOption) => {
      if (selectedOption.fromComponent == "normalFactory") {
        if (selectedOption.data[0] != undefined) {
           this.saved = [];
          for (let i = 0; i < selectedOption.data[0].length; i++) {
            this.saved.push(selectedOption.data[0][i]);
          }
        }
      }
      else if (selectedOption.fromComponent == "normalLocal") {
        if (selectedOption.data[0] != undefined) {
          this.locSaved = [];
          for (let i = 0; i < selectedOption.data[0].length; i++) {
            this.locSaved.push(selectedOption.data[0][i]);
          }
        }
      }
      else if (selectedOption.fromComponent == "normalPackage") {
        if (selectedOption.data[0] != undefined) {
          this.pacSaved = [];
          for (let i = 0; i < selectedOption.data[0].length; i++) {
            this.pacSaved.push(selectedOption.data[0][i]);
          }
        }
      }
      else if (selectedOption.fromComponent == "normalLocalPackage") {
        if (selectedOption.data[0] != undefined) {
          this.locPacSaved = [];
          for (let i = 0; i < selectedOption.data[0].length; i++) {
            this.locPacSaved.push(selectedOption.data[0][i]);
          }
        }
      }
    });
  }

  closeViewMore() {
    // added and removed codes selection
    /*var trueCodes =this.allCodesInit.filter((item)=>item.selected ==true);
    var falseCodes =this.allCodesInit.filter((item)=>item.selected ==false);
    
    trueCodes.forEach((itemSelected)=>{
      let removed = this.allCodesChanged.find((item)=>(itemSelected.code == item.code && itemSelected.selected != item.selected))
      if(removed != undefined)
      this.dataLoaderService.expertRemovedCodes.push(removed)
    });
    falseCodes.forEach((itemSelected)=>{
      let added = this.allCodesChanged.find((item)=>(itemSelected.code == item.code && itemSelected.selected != item.selected))
      if(added != undefined)
      this.dataLoaderService.expAdd.push(added.code)
    });*/
    this.dataLoaderService.flagDictionary.expertFlag = false;
    this.dataLoaderService.flagDictionary.viewMoreFlag = false;
    this.dataLoaderService.flagDictionary.factoryFlag = false;
    this.dataLoaderService.flagDictionary.localFlag = false;
    this.dataLoaderService.flagDictionary.packageFlag = false;
    this.progressService.illuminateRed();
  }

  selectFactory(item) {
    // for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForFactory= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
    let factoryCode;
		factoryCode = item.code.substr(0, 3);
    if (item.selected) {
      item.selected = false;
      const index = this.saved.indexOf(item);
      if (index > -1) {
        this.saved.splice(index, 1);
      }
      // this.dataLoaderService.expertRemovedCodes.push(item)
    } else {
      item.selected = true;
      this.saved.push(item);
      // this.dataLoaderService.expAdd.push(factoryCode)
    }
    this.dataLoaderService.flagDictionary.expertValidateFlag = true;
    this.dataLoaderService.flagDictionary.expertvalidated = false;
    this.dataLoaderService.flagDictionary.closeFlag = false;
    this.saveFactory();
  }
  
  saveFactory() {
    if (this.saved !== undefined) {
      this.priceService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.saved] });
      this.priceService.notifyExpertCompItem({ fromComponent: "expertFactory", data: [this.saved] });
      this.priceService.normalModePriceCalculation();
    }
    this.progressBarService.progressBarValidation();
    
  }
  selectLocal(item) {
    // for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForLocal= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
    let localCode;
		localCode = item.code.substr(0, 3);
    if (item.selected) {
      item.selected = false;
      const index = this.locSaved.indexOf(item);
      if (index > -1) {
        this.locSaved.splice(index, 1);
      }
      // this.dataLoaderService.expertRemovedCodes.push(item)
    } else {
      item.selected = true;
      this.locSaved.push(item);
      // this.dataLoaderService.expAdd.push(localCode)
    }
    this.dataLoaderService.flagDictionary.expertValidateFlag = true;
    this.dataLoaderService.flagDictionary.expertvalidated = false;
    this.dataLoaderService.flagDictionary.closeFlag = false;
    this.saveLocal();
  }
  saveLocal() {
    if (this.locSaved !== undefined) {
      this.priceService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.locSaved] });
      this.priceService.notifyExpertCompItem({ fromComponent: "expertLocal", data: [this.locSaved] });
      this.priceService.normalModePriceCalculation();
    }
    this.progressBarService.progressBarValidation();
  }

  selectPackage(item) {
    // for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForPackages= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
    let packageCode;
		packageCode = item.code.substr(0, 3);
    if (item.selected) {
      item.selected = false;
      const index = this.pacSaved.indexOf(item);
      if (index > -1) {
        this.pacSaved.splice(index, 1);
      }
      // this.dataLoaderService.expertRemovedCodes.push(item)
    } else {
      item.selected = true;
      this.pacSaved.push(item);
      // this.dataLoaderService.expAdd.push(packageCode)
    }
    this.dataLoaderService.flagDictionary.expertValidateFlag = true;
    this.dataLoaderService.flagDictionary.expertvalidated = false;
    this.dataLoaderService.flagDictionary.closeFlag = false;
    this.savePackage();

  }

  selectLocalPackage(item) {
    // for undo operation in alternative screen -start 
		this.dataLoaderService.flagDictionary.undoActivatedForLocalPackages= true;
		this.dataLoaderService.flagDictionary.undoActivated= true;
		// for undo operation in alternative screen -end
    let localPackageCode;
		localPackageCode = item.code.substr(0, 3);
    if (item.selected) {
      item.selected = false;
      const index = this.locPacSaved.indexOf(item);
      if (index > -1) {
        this.locPacSaved.splice(index, 1);
      }
      // this.dataLoaderService.expertRemovedCodes.push(item)
    } else {
      item.selected = true;
      this.locPacSaved.push(item);
      // this.dataLoaderService.expAdd.push(localPackageCode)
    }
    this.dataLoaderService.flagDictionary.expertValidateFlag = true;
    this.dataLoaderService.flagDictionary.expertvalidated = false;
    this.dataLoaderService.flagDictionary.closeFlag = false;
    this.savePackage();

  }

  savePackage() {
    if (this.pacSaved !== undefined || this.locPacSaved !== undefined) {

      this.priceService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.pacSaved] });
      this.priceService.notifyExpertCompItem({ fromComponent: "expertPackage", data: [this.pacSaved] });

      this.priceService.notifyNormalCompItem({ fromComponent: "normalLocalPackage", data: [this.locPacSaved] });
      this.priceService.notifyExpertCompItem({ fromComponent: "expertLocalPackage", data: [this.locPacSaved] });

      this.priceService.normalModePriceCalculation();
    }
    this.progressBarService.progressBarValidation();
  }


}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-view-all/expert-view-all.component.ts